import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';
import { ds } from 'mewe/stores/ds';
import fetchEvents from 'mewe/fetchers/fetch-events';
import fetchEvent from 'mewe/fetchers/fetch-event';
import { Theme } from 'mewe/constants';
import 'mewe/routes/app/event/feed';
import 'mewe/routes/app/event/media';
import { getOrCreate } from 'mewe/utils/fp';
import EventPageModel from 'mewe/stores/models/event-page-model';
import EmberObject from '@ember/object';

export default Route.extend({
  theme: Theme.EVENT,

  queryParams: {
    openEventInvitation: {
      refreshModel: false,
    },
  },

  routing: service('-routing'),
  dynamicDialogs: service(),

  openInvitations(id) {
    this.dynamicDialogs.openDialog('invitations-dialog', {
      eventData: ds.eventPages[id]?.rootEvent,
      isGroupMembersPicker: !!ds.eventPages[id]?.rootEvent?.groupId,
    });
  },

  model(params) {
    const openEventInvitation = params.openEventInvitation;

    const callback = () => {
      if (openEventInvitation) {
        this.openInvitations(params.event_id);
      }
    };

    const failCallback = () => {
      this.routing.transitionTo('app.myworld', []);
    };

    fetchEvent(params.event_id, callback, failCallback);
    fetchEvents('events', 'upcoming-events');

    return EmberObject.create({
      eventState: getOrCreate(ds.eventPages, EventPageModel, params.event_id),
      collection: ds.events.for('upcoming-events'),
      eventId: params.event_id,
      theme: this.get('theme'),
      app: this.modelFor('app'),
    });
  },

  deactivate() {
    // this way 'gr-{grId}' class is removed from view and it was there to set group color for group event page
    this.dispatch('events', 'clearEventData', this.controller.model?.eventId);
  },

  actions: {
    didTransition() {
      this.dynamicDialogs.closeAll();

      this.controller.setProperties({
        openEventInvitation: false,
      });
      return true;
    },
  },
});
